export default __webpack_public_path__ + "static/tanner@2x-098bfbf345dcf83c649a415dae042515.jpg";